const enc = new TextEncoder();

function toBase64(buf: ArrayBuffer): string {
  const bytes = new Uint8Array(buf);
  let bin = '';
  for (const b of bytes) {
    bin += String.fromCharCode(b);
  }
  return btoa(bin); // base64 PADRÃO
}

function fromBase64(b64: string): ArrayBuffer {
  const bin = atob(b64);                    // binary string (1 char = 1 byte)
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    bytes[i] = bin.charCodeAt(i);           // preserva 0–255 SEM UTF-8
  }
  return bytes.buffer;
}

export async function sha256Base64(text: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', enc.encode(text));
  return toBase64(digest);
}

export async function importHmacKey(sessionKeyB64: string): Promise<CryptoKey> {
  return crypto.subtle.importKey(
    'raw',
    fromBase64(sessionKeyB64),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );
}

export async function hmacSha256Base64(key: CryptoKey, canonical: string): Promise<string> {
  const sig = await crypto.subtle.sign('HMAC', key, enc.encode(canonical));
  return toBase64(sig);
}
